import "bootstrap/js/src/collapse";
import "jquery.cookie/jquery.cookie.js";

import Resource from "./components/ResourceLink.js";
import Copy from "./components/Copy.js";
import Video from "./components/Video.js";
import Navigation from "./components/Navigation.js";
import Search from "./components/Search.js";
import Scroller from "./components/Scroller.js";
import ScrollToActive from "./components/ScrollToActive.js";
import Carousel from "./components/Carousel.js";
import Cards from "./components/Cards.js";
import CookieBanner from "./components/CookieBanner.js";
import StickyFooter from "./components/StickyFooter.js";
import SingleFooter from "./components/SingleFooter.js";
import SearchForm from "./components/SearchForm.js";
import SortOptions from "./components/SortOptions.js";
import switchComponent from "./components/Switch.js";
import { ChatBaloon } from "./components/ChatBaloon.js";
import CollapseLinks from "./components/CollapseLinks.js";
import AjaxClasses from "./components/AjaxClasses.js";
import BackToTop from "./components/BackToTop.js";
import FormJar from "./components/FormJar.js";
import SwiperSlider from "./components/SwiperSlider.js";

// plain function for local scope; prevent variables are global scoped!
window.addEventListener("DOMContentLoaded", () => {
  new CookieBanner();
  new Navigation("#collapse-primary-navigation");
  new Resource([...document.getElementsByClassName("js_resourceLink")]);
  new Copy([...document.getElementsByClassName("js-copy")]);
  new Video();
  new ScrollToActive();
  new Scroller();
  new Search();
  new Carousel();
  new Cards();
  new SingleFooter();
  new SearchForm();
  new SortOptions();
  new ChatBaloon();
  new CollapseLinks(document.querySelector(".js-collapse-resource-link"));

  const switches = [...document.getElementsByClassName("onoffswitch")];
  if (switches) {
    switches.forEach((switchEl) => {
      new switchComponent(switchEl);
    });
  }

  new StickyFooter();
  new AjaxClasses();
  new BackToTop();
  new FormJar();
  new SwiperSlider();
  addGTMEvent();

  document.documentElement.className =
    document.documentElement.className.replace(/\bno-js\b/g, "js");
});

function addGTMEvent() {
  window.dataLayer = window.dataLayer || [];
  const els = document.querySelectorAll(".js-gtm-event");
  els.forEach((el) => {
    el.addEventListener("click", (e) => {
      window.dataLayer.push({
        event: "social share",
        platform: el.dataset.gtmType,
      });
    });
  });
}
